module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogTop":{"iconLabel":"Nevíte si rady?","hideContentLabel":"Skrýt popis","showContentLabel":"Číst více"}}}')
  delete Component.options._Ctor
}
